import React from 'react';
import { useIntl } from 'react-intl';

import ButtonItem from '@atlaskit/menu/button-item';
import Section from '@atlaskit/menu/section';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import Inline from '@atlaskit/primitives/inline';
import { xcss } from '@atlaskit/primitives/xcss';
import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import { token } from '@atlaskit/tokens';

import type { SpaceRole } from '../../model/space-roles-types.ts';
import { viewRolePermissionsMessages } from './viewRolePermissionsMessages.ts';

const navContainerStyles = xcss({
	width: '202px',
});

export const RoleListButtons = ({
	systemRoles,
	customRoles,
	activeRoleId,
	setActiveRoleId,
}: {
	systemRoles: SpaceRole[];
	customRoles?: SpaceRole[];
	activeRoleId: string;
	setActiveRoleId: (roleId: string) => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={navContainerStyles}>
			<Section>
				{[...systemRoles, ...(customRoles || [])].map((role) => (
					<ButtonItem
						key={role.id}
						isSelected={role.id === activeRoleId}
						onClick={() => setActiveRoleId(role.id)}
					>
						<Inline space="space.100" alignBlock="center" spread="space-between">
							<span>{role.name}</span>
							{role.isDisabled && (
								<EyeOpenStrikethroughIcon
									label={formatMessage(viewRolePermissionsMessages.roleDisabledLabel)}
									color={token('color.icon.danger')}
									size="small"
									spacing="none"
								/>
							)}
						</Inline>
					</ButtonItem>
				))}
			</Section>
		</Box>
	);
};
